import FormaPagoService from "@/api/services/finanzas/nomencladores/FormaPagoService"
import Vue from "vue"
//floder
const state = () => ({
    pagos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    PAGOS: state => {
        return state.pagos
    },
    PAGOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_PAGOS: (state, payload) => {
        state.pagos = payload
    },

    SET_PAGOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_PAGO: (state, payload) => {
        state.pagos.push(payload)
    },

    UPDATE_PAGO: (state, payload) => {
        state.pagos = state.pagos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_PAGO: (state, payload) => {
        state.pagos = state.pagos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_PAGOS: async ({ commit, state }, { filter, formasPagoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await FormaPagoService.get({ filter, formasPagoEstado, ...pagination })
            if (status === 200) {
                commit("SET_PAGOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las formas de pago, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_PAGOS: async ({ commit }) => {
        try {
            let { data, status } = await FormaPagoService.getAll()
            if (status === 200) {
                commit("SET_PAGOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_PAGOS: async ({ commit }) => {
        try {
            let { data, status } = await FormaPagoService.getAllRecords()
            if (status === 200) {
                commit("SET_PAGOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las formas de pago, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_PAGO: async ({ commit }, payload) => {
        try {
            let { data, status } = await FormaPagoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_PAGO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial de la forma de pago, inténtelo nuevamente"
            })
        }
    },

    ADD_PAGO: async ({ commit }, payload) => {
        try {
            let { data, status } = await FormaPagoService.post(payload)
            if (status === 201) {
                commit("ADD_PAGO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La forma de pago ha sido agregada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la forma de pago, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_PAGO: async ({ commit }, payload) => {
        try {
            let { data, status } = await FormaPagoService.put(payload)
            if (status === 200) {
                commit("UPDATE_PAGO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La forma de pago ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la forma de pago, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_PAGO: async ({ commit }, payload) => {
        try {
            let { status, data } = await FormaPagoService.delete(payload)
            if (status === 204) {
                commit("DELETE_PAGO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "La forma de pago ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_PAGO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La forma de pago ha sido deshabilitada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar la forma de pago, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
